import React from "react";

const PublicLayout = props => {
  return (
    <div>
          {props.children}
    </div>
  );
};

export default PublicLayout;